module.exports = __webpack_public_path__ + "img/djwh-img2.c2e2fb83.png";